import { render, staticRenderFns } from "./smart-button.vue?vue&type=template&id=852a9d22&scoped=true"
import script from "./smart-button.vue?vue&type=script&lang=js"
export * from "./smart-button.vue?vue&type=script&lang=js"
import style0 from "./smart-button.vue?vue&type=style&index=0&id=852a9d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852a9d22",
  null
  
)

export default component.exports